(() => {
  const script = document.currentScript;
  const threshold = Number(script?.dataset.threshold || 99000);
  const locale = script?.dataset.locale || 'es-MX';
  const currency = script?.dataset.currency || 'MXN';
  const initialCart = {
    item_count: Number(script?.dataset.itemCount || 0),
    items_subtotal_price: Number(script?.dataset.subtotal || 0),
  };
  let requestId = 0;
  let lastCart = initialCart;

  const moneyFormatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  const formatMoney = (cents) => moneyFormatter.format(cents / 100).replace('$', '$ ');

  const ensureProgress = () => {
    const drawer = document.querySelector('cart-drawer-component');
    const header = drawer?.querySelector('.cart-drawer__header');
    if (!drawer || !header) return null;

    let progress = drawer.querySelector('[data-ikigai-free-shipping]');
    if (progress) return progress;

    progress = document.createElement('aside');
    progress.className = 'ikigai-free-shipping';
    progress.dataset.ikigaiFreeShipping = '';
    progress.innerHTML = `
      <div class="ikigai-free-shipping__meta" aria-hidden="true">
        <span>Envío gratis</span>
        <span>Meta ${formatMoney(threshold)}</span>
      </div>
      <p class="ikigai-free-shipping__message" aria-live="polite"></p>
      <div
        class="ikigai-free-shipping__track"
        role="progressbar"
        aria-label="Progreso para obtener envío gratis"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <span class="ikigai-free-shipping__fill">
          <span class="ikigai-free-shipping__badge" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M3 7h11v9H3zM14 10h4l3 3v3h-7zM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
            </svg>
          </span>
        </span>
      </div>
    `;
    header.insertAdjacentElement('afterend', progress);
    return progress;
  };

  const renderProgress = (cart) => {
    lastCart = cart;
    const progress = ensureProgress();
    if (!progress) return;

    if (!cart?.item_count) {
      progress.hidden = true;
      return;
    }

    const subtotal = Number(cart.items_subtotal_price ?? cart.total_price ?? 0);
    const remaining = Math.max(threshold - subtotal, 0);
    const percentage = Math.min((subtotal / threshold) * 100, 100);
    const reached = remaining === 0;
    const message = progress.querySelector('.ikigai-free-shipping__message');
    const track = progress.querySelector('.ikigai-free-shipping__track');

    progress.hidden = false;
    progress.classList.toggle('is-reached', reached);
    progress.style.setProperty('--ikigai-shipping-progress', `${percentage}%`);

    if (message) {
      message.innerHTML = reached
        ? '<strong>Tu envío ya va por nuestra cuenta.</strong>'
        : `Te faltan <strong>${formatMoney(remaining)}</strong> para desbloquear envío gratis.`;
    }

    track?.setAttribute('aria-valuenow', String(Math.round(percentage)));
    track?.setAttribute('aria-valuetext', reached ? 'Envío gratis desbloqueado' : `${formatMoney(remaining)} restantes`);
  };

  const refreshProgress = async () => {
    const currentRequest = ++requestId;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (currentRequest === requestId) renderProgress(cart);
    } catch (_error) {
      // The cart remains fully functional if the optional progress request fails.
    }
  };

  const handleCartUpdate = (event) => {
    setTimeout(() => {
      const cart = event.detail?.resource;
      const hasCartTotals = Number.isFinite(Number(cart?.item_count))
        && Number.isFinite(Number(cart?.items_subtotal_price ?? cart?.total_price));

      if (hasCartTotals) {
        renderProgress(cart);
      } else {
        refreshProgress();
      }
    }, 0);
  };

  const initialize = () => {
    renderProgress(initialCart);
    refreshProgress();

    const observer = new MutationObserver(() => {
      if (!document.querySelector('[data-ikigai-free-shipping]')) renderProgress(lastCart);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener('cart:update', handleCartUpdate);
  document.addEventListener('shopify:section:load', refreshProgress);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
